import React from 'react';
import './index.css';
import Routes from './routes';

function App() {
  return <Routes />;
}

export default App;
